// CDaaS keeps every deploy addressable at /<version>/ as well as at the zone
// root, but a build can only carry one `<base href>`. A live deploy is built for
// the root, so when it is opened at its /<version>/ URL the base has to be
// corrected before AngularJS and React Router derive their mount paths from it.
// Both read the tag, so rewriting it is enough to align them.
export const resolveAppBasePath = (buildBasePath, deployVersion, currentPath) => {
  if (!deployVersion) return buildBasePath;

  const versionPath = `/${deployVersion}/`;
  if (currentPath === `/${deployVersion}` || currentPath.startsWith(versionPath)) {
    return versionPath;
  }

  return buildBasePath;
};

// Must run before $location is instantiated, and after the initial script tags
// have been resolved against the build's own base.
const applyAppBasePath = () => {
  const baseElement = document.querySelector('base');
  const buildBaseHref = baseElement?.getAttribute('href');
  if (!buildBaseHref) return;

  const deployVersion = document
    .querySelector('meta[name="deploy-version"]')
    ?.getAttribute('content');
  if (!deployVersion) return;

  let buildBase;
  try {
    buildBase = new URL(buildBaseHref, window.location.origin);
  } catch {
    return;
  }

  const resolved = resolveAppBasePath(
    buildBase.pathname,
    deployVersion,
    window.location.pathname
  );
  if (resolved === buildBase.pathname) return;

  baseElement.setAttribute('href', new URL(resolved, buildBase.origin).toString());
};

export default applyAppBasePath;
